import React, { useState } from "react";
import {
  TextField,
  InputAdornment,
  FormControl,
  FormHelperText,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const InputBox = (props) => {
  const [focused, setFocused] = useState(false);
  const theme = useTheme();
  const stylesCSS = {
    input: {
      "& input[type=number]": {
        MozAppearance: "textfield",
      },
      "& input[type=number]::-webkit-outer-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "& input[type=number]::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
    },
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const handleChange = (event) => {
    props?.setValue(event.target.value);
  };

  return (
    <Box
      position="relative"
      marginBottom={2}
      width={"100%"}
     >
      <FormControl
        size="small"
        variant="standard"
        fullWidth
        error={Boolean(props?.error)}
      >
        <div
          style={{
            border: `2px solid ${
              focused
                ? props?.error
                  ? theme.palette.primary.error
                  : theme.palette.primary.main
                : props?.error
                ? theme.palette.primary.error
                : theme.palette.primary.gray
            }`,
            paddingTop: "8px",
            paddingRight: "8px",
            borderRadius: "8px",
          }}
        >
          <TextField
            error={props?.error}
            autoComplete="off"
            type={props?.type}
            max={props?.maxLength}
            size="small"
            label={props?.label}
            variant="standard"
            value={props?.value}
            onSubmit={props?.onSubmit}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">{props?.icon}</InputAdornment>
              ),
              disableUnderline: true,
              style: { textAlign: "right" },
            }}
            InputLabelProps={{
              style: {
                color: theme.palette.primary.grayLabel,
                top: focused || props?.value ? "" : "-8px",
              },
            }}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                props?.onSubmit();
              }
            }}
            disabled={props?.isLoading}
            fullWidth
            sx={{
              width: "100%",
              ...stylesCSS.input,
            }}
          />
        </div>
        {props?.error && <FormHelperText>{props?.error}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default InputBox;
